import {
	EngineCommunicationChannels,
	LoggerAction,
	StorageUploadFileChannel,
} from '@webitel/api-services/gen/models';
import { RingtoneType } from '@webitel/ui-sdk/enums';
import { NotificationType } from '../../../modules/settings/modules/notifications/enums/NotificationType';

export default {
	auth: {
		register: "Ro'yxatdan o'tish",
		login: 'Kirish',
		registerReset: 'Parolni tiklash',
		detailsSubtitle: "Quyidagi ma'lumotlarni kiriting",
		resetPasswordLink: 'Parolni unutdingizmi?',
		user: 'Foydalanuvchi nomi',
		password: 'Parol',
		confirmPassword: 'Parolni takrorlang',
		key: 'Litsenziya kaliti',
		registerSubmit: "Ro'yxatdan o'tish",
		resetSubmit: 'Tiklash',
		loginSubmit: 'Kirish',
		carousel: {
			title1: 'Cloud vs. On-Site',
			text1:
				"Sekurity siyosati ma'lumotlarni saqlash va kulning xizmatlarini ishlatishni ruxsat etmaydi? Webitel bilan siz saytizda kontakt markazini qurishingiz mumkin!",

			title2: 'Multichannel VS Omni-Channel',
			text2:
				"Do'stingiz bilan har yerda va har vaqtda bog'laning! Har qanday murakkablikdagi IVR-menyu, chiqish, kirish interaktiv kampaniyalar yoki ijtimoiy tarmoqlarda xabar - endi u yanada oson!",

			title3: 'Fault-tolerant infrastructure',
			text3:
				"Yaxshi tayyorlanmagan to'xtashlarni yo'qotish. Tezroq kattalashtirish va xatolikka qarshi tayyorlash imkoniyati sizga bir vaqtda 1000 dan ortiq foydalanuvchi zvonkalarni qo'llab-quvvatlashingiz mumkin.",

			title4: 'Design',
			text4:
				"Yangi minimalist interfeys va eng foydalanuvchi admin paneli bilan siz barcha kerakli funksiyalarga tez kirish imkonini beradi. Kam bosish - ko'proq xususiyatlar.",

			title5: 'Yangi agent guruhi ish moduli',
			text5:
				"Eng samarali zvonkani taqsimlash. Agent bir vaqtning o'zida bir nechta xususiyatga ega bo'lishi mumkin. Foydalanuvchi faqat mutaxassislar bilan xizmat ko'rsatadi.",

			title6: 'Ruxsatlarini boshqarish',
			text6:
				"Yangi ruxsatlar boshqarish moduli - yangi boshqarish imkoniyatlari. Foydalanuvchilar faqat bo'limlarni o'zgartirishi mumkin, hamda amallarni.",
		},
	},

	header: {
		logout: 'Chiqish',
		docs: "Do'kon",
	},

	appNavigator: {
		title: 'Webitel dasturlar',
		admin: 'Admin',
		agent: 'Agent ish joyi',
		supervisor: 'Supervisor ish joyi',
		audit: 'Audit',
		history: 'Zvonk tarixi',
		grafana: 'Grafana',
	},

	settings: {
		settings: 'Sozlamalar | Sozlamalar',
		changePassword: "Parolni o'zgartirish",
		language: 'Til',
		fallbackLanguage: 'Standart til',
		webPhone: 'WebPhone',
		useWebPhone: 'WebPhone ishlatish',
		useStun: 'STUN ishlatish',
		notifications: {
			[NotificationType.NewMessageSound]: 'Yangi xabar ovozi',
			[NotificationType.NewChatSound]: 'Yangi chat ovozi',
			[NotificationType.SelfAssignedCallSound]:
				"O'z-o'ziga tayinlangan qo'ng'iroq ovozi",
			[NotificationType.ChatEndSound]: 'Chat tugashi ovozi',
			[NotificationType.CallEndSound]: "Qo'ng'iroq tugashi ovozi",
			[NotificationType.TaskEndSound]: 'Vazifa tugashi ovozi',
			[NotificationType.ChatEndPush]: 'Chat tugashi push bildiruvchi',
			[NotificationType.CallEndPush]: "Qo'ng'iroq tugashi push bildiruvchi",
			[NotificationType.TaskEndPush]: 'Vazifa tugashi push bildiruvchi',
			[NotificationType.SocketCloseSound]: 'Ulanish uzilishi ovozi',
		},
		ringtones: {
			title: "Qo'ng'iroq ringtonini o'zgartirish",
			ringtone: 'Zvonk ton',
			customRingtone: 'Xususiy zvonk tonini ishlatish',
		},
		ringtoneVolume: {
			title: 'Ovoz sozlamalari',
			[RingtoneType.Call]: "Qo'ng'iroq",
			[RingtoneType.Chat]: 'Chat',
			[RingtoneType.Task]: 'Vazifa',
		},
		security: {
			security: 'Xavfsizlik',
			logoutTitle: 'Ushbu foydalanuvchini boshqa qurilmalardan chiqarish',
		},
	},

	validation: {
		email: 'Elektron pochta-shakli',
		required: 'Bu maydon majburiy',
		sameAs: "Noto'g'ri parol",
		gatewayHostValidator: "IPv4 yoki FQDN shaklida bo'lishi kerak",
		ipValidator: "IPv4 shaklida bo'lishi kerak",
		macValidator: "MAC shaklida bo'lishi kerak",
		numeric: "Raqam bo'lishi kerak",
		requiredArrayValue: "Massiv bo'sh bo'lmasligi kerak",
		isPositiveValue: "Qiymat musbat son bo'lishi kerak",
		cron: 'Nogiron cron ifoda',
		hourRange: "Soatlar 00 dan 23 gacha bo'lishi kerak",
		timerangeStartLessThanEnd:
			'"Dan" vaqti "Gacha" vaqtidan kech bo\'lishi mumkin emas',
		timerangeNotIntersect:
			"Bir kundagi vaqt oralig'lari bir-biriga kesilib o'tmasligi kerak",
	},

	nav: {
		directory: {
			directory: 'Katalog',
		},
		routing: {
			routing: "Yo'naltirish",
		},
		lookups: {
			lookups: 'Kutubxonalar',
		},
		ccenter: {
			ccenter: 'Kontakt markazi',
		},
		integrations: {
			integrations: 'Integratsiyalar',
		},
		permissions: {
			permissions: 'Ruxsatlar',
		},
		system: {
			system: 'Tizim',
		},
	},

	home: {
		dashboard: 'Bosh sahifa',
		welcomeText: '',
		news: 'Yangiliklar',
	},

	objects: {
		all: '{entity} barchasi',
		administration: 'Boshqaruv',
		general: 'Umumiy',
		new: 'Yangi',
		add: "Qo'shish",
		create: 'Yaratish',
		read: "O'qish",
		edit: 'Tahrirlash',
		delete: "O'chirish",
		save: 'Saqlash',
		saved: 'Saqlangan',
		saveAs: 'Saqlash',
		close: 'Yopish',
		next: 'Keyingi',
		back: 'Orqaga',
		change: "O'zgartirish",
		name: 'Nomi',
		title: 'Sarlavha',
		description: 'Tavsif',
		user: 'Foydalanuvchi',
		users: 'Foydalanuvchilar',
		action: 'Amal',
		allow: 'Ruxsat',
		password: 'Parol',
		history: 'Tarix',
		copy: 'Nusxa olish',
		copied: 'Nusxa olingan!',
		createdAt: 'Yaratilgan',
		createdBy: 'Yaratilgan',
		online: 'Onlayn',
		offline: 'Oflayn',
		on: 'On',
		off: 'Off',
		ok: 'OK',
		enabled: 'Ishlatilgan',
		status: 'Holat',
		from: 'Dan',
		to: 'Gacha',
		importJSON: 'JSON import qilish',
		addNew: "Yangi qo'shish",
		provider: 'Provider',
		default: 'Asosiy',
		service: 'Xizmat',
		tts: 'Matn-to-Ses',
		stt: 'Ses-to-Matn',
		key: 'Kalit',
		ID: 'ID',
		email: ({ linked }) => linked('vocabulary.emails'),
		updatedAt: "O'zgartirilgan",
		emptyWorkspace: "Hozircha ma'lumotlar yo'q",
		emptyResultSearch: "Qidiruvingiz natijalari yo'q",

		deleteConfirmation: {
			title: "O'chirishni tasdiqlash",
			askingAlert:
				"Siz {count} ma'lumotni o'chirmoqchimisiz? | Siz {count} ma'lumotni o'chirmoqchimisiz?",
			undoneActionAlert: 'Bu amal qayta tiklanmaydi.',
			deleteAll: 'HAMMASI',
		},
		generalInfo: "Umumiy ma'lumot",
		objectHeader: {},
		directory: {
			directory: 'Katalog',
			passwordInfo:
				"Qiymatni o'zgartirmoqchi bo'lsangiz (yoki yangi qo'shmoqchi bo'lsangiz) bo'sh maydonga qo'yilsin. Bo'sh maydonga qo'yilsa, qiymat o'zgarishi qoladi",
			users: {
				users: 'Foydalanuvchi | Foydalanuvchilar',
				allUsers: 'Barcha foydalanuvchilar',
				searchPlaceholder: 'Ism, login, kengaytmaslar, holat',
				login: 'Login',
				extensions: 'Kengaytmaslar',
				state: 'Holat',
				DnD: 'DnD',
				status: 'Holat',
				roles: 'Ruxsatlar',
				tokens: 'Tokens',
				usage: 'Ishlatish',
				expiryDays: 'Amal qilish muddati',
				expiryDate: 'Amal qilish muddati',
				roleAdmin: 'Admin',
				license: 'Litsenziya',
				devices: 'Quvurlar',
				defaultDevice: "Asosiy quvur (tanlangan quvurlar ro'yxatidan)",
				deviceNotFound: 'Quvur topilmadi?',
				createNewDevice: "Yangi qo'shish",
				variables: "O'zgaruvchilar",
				varKey: 'Kalit',
				varVal: 'Qiymat',
				token: 'Token | Tokens',
				tokenPopupHeader: 'Sizning kalit faylingiz muvaffaqiyatli yaratildi!',
				tokenPopupText:
					'Endi yoki uni nusxasini oling. Agar siz hozircha kalit faylini yuklamasangiz, siz kalit faylingizni qayta olishimiz mumkin emas. Sizning sekuritynizni himoya qilish uchun kalit faylingizni xavfsiz saqlang va uni boshqarish.',
				tokenPopupCopy: 'Nusxasini olish',
				tokenPopupSave: 'TXT sifatida saqlash',
				userIp: 'Foydalanuvchi IP',
				userId: 'Foydalanuvchi ID',
				download: 'Yuklash',
				regenerate: 'Qayta yaratish',
				askingAlert:
					'Siz kodni qayta yaratmoqchimisiz? Foydalanuvchi kirishga ruxsat etilmaydi',
				chatName: "Chat ko'rsatish nomi",
				temporaryPassword: 'Vaqtinchalik parol',
				communications: 'Aloqalar',
				generateDevice: 'Qurilma yaratish',
				deviceGenerationTitle: 'Qurilma yaratish',
				deviceGeneration:
					'Bu amal ushbu foydalanuvchi uchun avtomatik ravishda yangi qurilma yaratadi.',
				deviceWasGenerated: 'Qurilma yaratildi',
				deviceGenerationConfirmTitle: 'Qurilma yaratishni tasdiqlash',
				generateDeviceConfirmation:
					'Joriy qurilmalar yaratilgan qurilma bilan almashtiriladi. Davom etasizmi?',
				authorizationSecurity: 'Avtorizatsiya va xavfsizlik',
				mustChangePassword:
					"Foydalanuvchi birinchi kirishda parolni o'zgartirishi kerak.",
				extensionsHelperText:
					'Ichki raqam faqat raqamlardan iborat boʻlishi kerak',
				csvMappingFields: {
					login: ({ linked }) => linked('vocabulary.login'),
					name: 'Ism',
					extension: ({ linked }) =>
						linked('objects.directory.users.extensions'),
					email: ({ linked }) => linked('vocabulary.emails'),
				},
				logout: {
					endAllSessions: 'Barcha sessiyalarni yakunlash',
					endAllMySessions: 'Mening barcha sessiyalarimni yakunlash',
					endSessionConfirmation: 'Sessiyani yakunlashni tasdiqlash',
					endSessionConfirmationText: 'Barcha sessiyalarni yakunlamoqchimisiz?',
					endMultipleSessionsConfirmationText:
						'Siz {count} foydalanuvchi uchun barcha seanslarni yakunlashga ishonchingiz komilmi?',
					tooltip: 'Foydalanuvchi barcha qurilmalardan chiqariladi',
				},
			},
			license: {
				customers: 'Mijozlar',
				license: 'Litsenziya | Litsenziyalar',
				licenseId: 'ID',
				allCustomers: 'Barcha mijozlar',
				allLicenses: 'Barcha litsenziyalar',
				serial: 'Seriya',
				product: 'Mahsulot',
				validFrom: "Faol bo'lishi",
				validTill: "Faol bo'lishi",
				used: 'Ishlatilgan',
				limit: 'Limit',
				status: 'Holat',
				competitive: 'Konkurent',
				searchPlaceholder: 'Seriya, mahsulot',
				domain: 'Domen',
				daysToExpire: {
					0: 'Yaroqli',
					30: '30 yoki kamida',
					90: '90 yoki kamida',
					days: ' kun',
				},
				importLicense: 'Litsenziya import qilish',
				licenseKey: 'Litsenziya kaliti',
			},
			devices: {
				devices: 'Quvur | Quvurlar',
				newDevice: 'Yangi quvur',
				newDeviceDescription: 'Yangi quvur tavsifi',
				allDevices: 'Barcha quvurlar',
				searchPlaceholder: 'Ism, foydalanuvchi, auth ID & kabinet ID',
				authId: 'Auth ID',
				presence: 'Mavjudlik',
				hotdesk: 'Hot desking',
				hotdeskDevice: 'Hot desking quvuri',
				hotdeskDeviceSettings: 'Hot desking quvuri sozlamalari',
				hotdeskIncorrectInput: "Noto'g'ri Host nomi",
				hotdeskInputHint:
					"Bu quvurni aniqroq kiritish uchun uni yaxshi hot-desking aliaslariga qo'ying. Valid nom faqat quyidagi belgilardan tashkil topishi kerak: A-Z, a-z, 0-9, -, _",
				deviceSettings: 'Quvur sozlamalari',
				hostName: 'Host nomi',
				phoneInfo: "Telefon ma'lumoti",
				phone: 'Telefon',
				vendor: 'Tavsif',
				model: 'Model',
				ipv4: 'IPv4',
				mac: 'MAC',
				deviceHistory: 'Quvur tarixi',
				loggedIn: 'Kirgan',
				loggedOut: 'Chiqib ketgan',
				state: {
					nonreg: "Ro'yxatdan o'tmagan",
					reged: "Ro'yxatdan o'tgan",
					ringing: 'Zvonk',
					dialing: 'Dial',
					dialog: 'Dialog',
					onhold: 'On hold',
				},
				passwordSetFromAccount:
					"Agar parolni o'rnatmoqchi bo'lmasangiz, u hisobingiz bilan bir xil bo'ladi",
				csvMappingFields: {
					account: ({ linked }) => linked('webitelUI.headerActions.account'),
					name: ({ linked }) => linked('reusable.name'),
					password: ({ linked }) => linked('vocabulary.password'),
					vendor: 'Ishlab chiqaruvchi',
					model: 'Model',
					mac: 'MAC manzili',
					ip: 'IP manzili',
				},
			},
		},
		permissions: {
			permissions: 'Ruxsatlar',
			permissionsRole: 'Ruxsatlar | Ruxsatlar',
			allRoles: 'Barcha ruxsatlar',
			searchPlaceholder: 'ruxsatlar ..',
			roles: {
				permissions: {
					permissions: 'Ruxsatlar | Ruxsatlar',
					add: "Qo'shish",
					delete: "O'chirish",
					read: 'Tanlash',
					write: "O'zgartirish",
					eavesdropCall: 'Zvonkni kuzatish',
					playbackRecordFile: "Zvonk yozuv faylini o'qish",
					timeLimitedRecordFile: "Vaqtli zvonk yozuv faylini o'qish",
					resetActiveAttempts: 'Aktiv urinishlarni qayta tiklash',
					limitWorkspaceContacts: 'Ish joyidagi mijozlar sonini cheklov',
					exportDataGrid: "Ma'lumotlar jadvalini faylga eksport qilish",
					viewCdrPhoneNumbers: "CDR telefon raqamlarini ko'rish",
					manageUserRoles: 'Foydalanuvchi ruxsatlarini boshqarish',
					manageUserLicense: 'Foydalanuvchi litsenziyalarini boshqarish',
					changeUserPassword: "Foydalanuvchi parolini o'zgartirish",
					systemSetting: 'Tizim sozlamalarini boshqarish',
					addDescription: 'Ruxsat beradi har qanday obyekt yaratish',
					deleteDescription: 'Ruxsat beradi har qanday obyektni olib tashlash',
					readDescription: 'Ruxsat beradi har qanday obyektni tanlash',
					writeDescription: "Ruxsat beradi har qanday obyektni o'zgartirish",
					eavesdropCallDescription:
						'Ruxsat beradi aktiv konversatsiyani kuzatish',
					playbackRecordFileDescription:
						"Ruxsat beradi zvonk yozuv fayllarini o'qish",
					timeLimitedRecordFileDescription:
						"Ruxsat beradi vaqtli zvonk yozuv fayllarini o'qish",
					resetActiveAttemptsDescription:
						'Ruxsat beradi aktiv urinishlarni qayta tiklash',
					limitWorkspaceContactsDescription:
						"Ruxsat beradi ish joyidagi mijozlar ro'yxatini ko'rish",
					exportDataGridDescription:
						"Ruxsat beradi ma'lumotlar jadvalini faylga eksport qilish",
					viewCdrPhoneNumbersDescription: "CDR telefon raqamlarini ko'rish",
					manageUserRolesDescription:
						'Ruxsat beradi foydalanuvchi ruxsatlarini boshqarish',
					manageUserLicenseDescription:
						'Ruxsat beradi foydalanuvchi litsenziyalarini boshqarish',
					changeUserPasswordDescription:
						"Ruxsat beradi foydalanuvchi parolini o'zgartirish",
					systemSettingDescription:
						"Ruxsat beradi Konfiguratsiya bo'limiga kirish va boshqarish",
					schemeVariables: "Global o'zgaruvchilarni boshqarish",
					controlAgentScreen: 'Agent ekranini boshqarish',
					schemeVariablesDescription:
						"Ruxsat beradi Global o'zgaruvchilar bo'limiga kirish va boshqarish",
				},
				addPermission: "Ruxsat qo'shish",
				usage: 'Ishlatish',
				applicationsAccess: {
					applicationsAccess: 'Dasturlar kirishi | Dasturlar kirishi',
					access: 'Kirish',
				},
			},
			object: {
				object: 'Obyektlar',
				allObjects: 'Barcha obyektlar',
				ObAC: 'Operatsiyalar tizimi bilan boshqariladi',
				RbAC: 'Yozuvlar tizimi bilan boshqariladi',
				operations: 'Operatsiyalar',
				searchPlaceholder: 'obyektlar ..',
				newPermissionRole: 'Yangi ruxsat beruvchi',
				rbacDefault: 'Asosiy yozuv asosida ruxsat',
				grantor: 'Beruvchi',
				grantee: 'Ruxsat beruvchi',
				create: 'Yaratish',
				delete: "O'chirish",
				accessMode: {
					1: 'Ruxsat etilmagan',
					2: 'Ruxsat etilgan',
					3: 'Delegatsiya bilan ruxsat etilgan',
				},
			},
		},
		lookups: {
			lookups: 'Kutubxonalar',
			skills: {
				skills: 'Xususiyat | Xususiyatlar',
				capacity: 'Sigim',
				minCapacity: 'Minimal sigim',
				minCapacityLessOrEqualToMaxCapacityValidator:
					"Sigim minimal sigimdan katta yoki teng bo'lishi kerak",
				maxCapacity: 'Maksimal sigim',
				maxCapacityMoreOrEqualToMinCapacityValidator:
					"Sigim maksimal sigimdan kichik yoki teng bo'lishi kerak",
				lvl: 'Daraja',
				agentSkills: 'Agent xususiyati | Agent xususiyatlari',
				allSkills: 'Barcha xususiyatlar',
				state: 'Holat',
				stateForAll: 'Barcha uchun holat',
				changeSkillTo: "Xususiyatni o'zgartirish",
				changeAgentsSkill: "Agent xususiyatini o'zgartirish",
				totalAgents: 'Jami agentlar',
				activeSkillAgents: 'Aktiv xususiyat agentlari',
				assignSkillToAgents: 'Xususiyatni agentlarga bajarish',
				assignAgent: 'Agentni bajarish',
				selectCapacityAndState: 'Sigim va holatni tanlash',
			},
			buckets: {
				buckets: 'Bucket | Buckets',
				allBuckets: 'Barcha bucketlar',
				addBucket: "Bucket qo'shish",
			},
			blacklist: {
				blacklist: "Ro'yxat | Ro'yxatlar",
				allBlacklists: "Barcha ro'yxatlar",
				number: 'Raqam | Raqamlar',
				newNumber: 'Yangi raqam',
				numbersCount: 'Raqamlar',
				expireAt: 'Yaroqli',
				temporary: 'Vaqtinchalik',
				csvMappingFields: {
					number: ({ linked }) => linked('vocabulary.number'),
					description: ({ linked }) => linked('vocabulary.description'),
					expireAt: ({ linked }) => linked('vocabulary.expireAt'),
				},
				importResult:
					"Import qilingan raqamlar: {imported}. O'tkazib yuborilgan dublikatlar: {skipped}.",
			},
			media: {
				mediaFiles: 'Media fayl | Media fayllar',
				allMediaFiles: 'Barcha media fayllar',
				createdAt: 'Yaratilgan',
				format: 'Format',
				size: "O'lcham",
				textToSpeech: "Matnni sesga o'tkazish",
				popupSettings: 'Sozlamalar',
				lang: 'Til',
				voice: 'Ovoz',
				token: 'Token',
				key: 'Kalit',
				dragPlaceholder: 'Fayllarni tortish va tushirish',
				dragPlaceholderHere: 'bu erda.',
				tts: {
					hint: 'Audio fayl yaratish',
					textType: {
						textType: 'Matn turi',
						ssml: 'SSML',
					},
				},
			},
			regions: {
				regions: 'Lokatsiya | Lokatsiyalar',
				allRegions: 'Barcha lokatsiyalar',
			},
			timezone: {
				timezone: 'Vaqt zonasi | Vaqt zonalar',
			},
			calendars: {
				calendars: 'Kalendar | Kalendarlar',
				allCalendars: 'Barcha kalendarlar',
				searchPlaceholder: 'Ism, tavsif...',
				timezone: 'Vaqt zonasi',
				start: 'Boshlanish',
				end: 'Tugash',
				workWeek: 'Ish kuni',
				specialTime: 'Xususiy vaqt',
				holidays: 'Kun | Kunlar',
				date: 'Sana',
				repeat: 'Qayta',
				fulltime: 'Vaqtinchalik',
				everyYear: 'Har yilda qayta',
				newHoliday: 'Yangi kun',
				mon: 'Dushanba',
				tue: 'Seshanba',
				wed: 'Chorshanba',
				thu: 'Payshanba',
				fri: 'Juma',
				sat: 'Shanba',
				sun: 'Yakshanba',
				workingTime: 'Ish vaqti',
				workStart: 'Ish vaqti boshlanishi',
				workStop: 'Ish vaqti tugashi',
			},
			communications: {
				communications: 'Kommunikatsiya turi | Kommunikatsiya turlari',
				allCommunications: 'Barcha kommunikatsiya turlari',
				addCommunication: "Kommunikatsiya qo'shish",
				missingCommunication: "Iltimos, kommunikatsiya turini qo'shing",
				code: 'Kod',
				channels: {
					[EngineCommunicationChannels.Phone]: 'Telefon',
					[EngineCommunicationChannels.Email]: 'Elektron pochta',
					[EngineCommunicationChannels.Messaging]: 'Xabar',
				},
			},
			pauseCause: {
				pauseCause: 'Tanaffus sabablari',
				allPauseCause: "Barcha agent to'xtash sabablari",
				limit: 'Limit (min)',
				min: 'min',
				allowAdmin: "Admin bu holatni o'zgartirishi mumkin",
				allowSupervisor: "Supervisor bu holatni o'zgartirishi mumkin",
				allowAgent: "Agent bu holatni o'zgartirishi mumkin",
			},
			quickReplies: {
				quickReplies: 'Tez javob | Tez javoblar',
			},
			activityTypes: {
				activityTypes: 'Faoliyat turi | Faoliyat turlari',
			},
		},
		routing: {
			routing: "Yo'naltirish",
			ip: 'IP',
			protocol: 'Protokol',
			port: 'Port',
			configuration: 'Konfiguratsiya',
			schema: 'Flow sxemasi',
			json: 'JSON',

			flow: {
				flow: 'Flow sxemasi | Flow sxemalar',
				allFlowSchemas: 'Barcha flow sxemalar',
				createFlowSelectionPopup: 'Yangi flow yaratish',
				createNew: "Yangi qo'shishmi?",
				editor: 'Tahrirlash',
				diagram: {
					diagram: 'Diagramma',
					description:
						'Yangi flowni Webitel Flow Diagramm toolidan foydalanish orqali yaratish',
				},
				code: {
					code: 'Kod',
					description:
						'Yangi flowni JSON-sxemasi kodi tahrirlash orqali yaratish',
				},
				askingAlert:
					'Siz "{name}" ga tayyorlagan o\'zgarishlarni saqlashni xohlaysizmi?',
			},

			dialplan: {
				dialplan: 'Dialplanlar',
				dialplanRules: 'Dialplan qoidalari',
				pattern: "Ma'lumotnoma raqami",
				dialplanRule: 'Dialplan qoidasi',
				position: "O'rnatish",
				allowTransfer: "O'tkazishga ruxsat berish",
			},

			chatplan: {
				chatplan: 'Chatplan | Chatplans',
				allChatplans: 'Barcha chatplans',
			},

			gateways: {
				gateways: 'Gateway | Gateways',
				allGateways: 'Barcha gateways',
				trunkingGateway: 'Trunking gateway',
				registerGateway: 'Register gateway',
				stateSuccess: 'Muvaffaqiyatli',
				stateFailed: 'Yaroqsiz',
				stateProgress: 'Bajarilmoqda',
				stateNonreg: "Ro'yxatdan o'tmagan",
				proxy: 'Proxy',
				searchPlaceholder: 'gateway qidiruvi...',
				host: 'Host',
				trunkingACL: "Trunking kirish kontrol ro'yxati",
				hostnameTrunking: 'Server/Gateway nomi yoki IP',
				hostnameRegister: 'Registrator/Server/Gateway nomi yoki IP',
				expire: 'Yaroqli',
				authID: 'Login',
				account: 'Hisob',
				outboundProxy: 'Chiqish proxy nomi yoki IP',
				newGateway: 'Yangi gateway',
				newGatewayDescription: 'Yangi gateway tavsifi',
				SIPregistrations: "SIP Ro'yxat",
				SIPregistrationsDescription: "SIP ro'yxat tavsifi",
				SIPtrunking: 'SIP trunking',
				SIPtrunkingDescription: 'SIP trunking tavsifi',
			},
			chatGateways: {
				templates: {
					templates: 'Shablon | Shablonlar',
					title: 'Ish joyidagi foydalanuvchi nomi',
					close: 'Chat tugash xabari',
					join: 'Agent kirish xabari',
					left: 'Agent ulanish xabari',
					filePolicyFail: 'Taqiqlangan fayl formati',
				},
				chatGateways: 'Chat gateway | Chat gateways',
				allChatGateways: 'Barcha chat gateways',
				telegramBot: {
					telegramBot: 'Telegram Bot',
				},
				telegramApp: {
					telegramApp: 'Telegram App',
					signedAs: "Siz ro'yxatdan o'tingiz",
					joinTelegram: 'Telegramga kirish',
					signOut: 'Telegramdan chiqish',
					metadata: {
						apiId: 'API id',
						apiHash: 'API hash',
					},
				},
				infobip: {
					infobip: 'Infobip',
				},
				messenger: {
					meta: 'Meta',
					addOrRemovePages: "Sahifalarni qo'shish yoki olib tashlash",
					accounts: 'Hisoblar',
					metadata: {
						clientId: 'App ID',
						clientSecret: 'App Secret',
						apiVersion: 'API versiyasi',
						apiVersionHint: 'Format: vXX.X (masalan, v24.0)',
					},
					facebook: {
						pages: 'Facebook sahifalari',
						subscription: 'Webhook obuna',
					},
					instagram: {
						instagram: 'Instagram',
						comments: 'Izohlarini kuzatish',
						mentions: 'Izohlarini kuzatish',
					},
					whatsapp: {
						whatsapp: 'Whatsapp',
						token: 'Token',
						status: 'Holat',
						number: 'Telefon raqami',
						review: 'Qaror',
					},
				},
				viber: {
					viber: 'Viber',
					style: {
						style: 'Stil',
						btnBackColor: 'Tugma fon rangi',
						btnFontColor: 'Tugma matn rangi',
					},
				},
				webchat: {
					webchat: 'Web chat',
					copyCode: 'Sayt uchun kodni nusxasini olish',
					copyCodeHint:
						"Widget sozlamalarini o'zgartirgandan keyin har safar saytga Widget kodini qayta yaratish kerak",
					metadata: {
						mediaMaxSize: "Max media o'lchami (MB)",
					},
					view: {
						view: "Ko'rish",
						borderRadius: 'Tugma shakli',
						language: 'Til',
						position: "O'rnatish",
						btnColor: 'Tugma rangi',
						logoUrl: 'Logo URL',
						logoHint:
							"Qo'llab-quvvatlangan logo formati 'JPEG' yoki 'PNG', 24x24px",
						rounded: 'Yaxlit',
						square: "To'rtburchak",
						right: "O'ng",
						left: 'Chap',
					},
					recaptcha: {
						recaptcha: 'reCAPTCHA',
						sitekey: 'Sayt kaliti',
						secret: 'Maxfiy kalit',
						threshold: 'Shart',
						showFlag: "reCAPTCHA belgini ko'rsatish",
					},
					chat: {
						chat: 'Chat',
						openTimeout: 'Ochiq vaqt',
						openTimeoutSec: 'Ochiq vaqt (sek)',
					},
					appointment: {
						appointment: 'Rejalar',
						days: 'Kunlar',
						availableAgents: 'Mavjud agentlar',
						showEmailField: "Elektron pochta maydoni ko'rsatish",
						showMessageField: "Xabar maydoni ko'rsatish",
						resultPageText: 'Natija sahifasi matni',
						headingText: 'Sarlavha matni',
						subheadingText: 'Subheading matni',
						showDefaultHeading:
							"Natija sahifasida asosiy sarlavha va subheading ko'rsatish",
					},
					alternativeChannels: {
						alternativeChannels: 'Boshqa kanal',
						title: 'Xabar kanalari',
						email: 'Elektron pochta',
						whatsapp: 'WhatsApp',
						telegram: 'Telegram',
						messenger: 'Messenger',
					},
					call: {
						title: 'Onlayn zvonk',
						url: 'WebSocket Endpozit',
					},
				},
				customChat: {
					customChat: 'Xususiy chat',
					customChatGateway: 'Xususiy chat gateway',
					appSecretHint: "Ushbu maydoni o'zgartirganda integratsiya buziladi",
					metadata: {
						appSecret: 'App Secret',
						callback: 'Callback',
					},
				},
				uri: 'URI',
				newChatGateway: 'Yangi chat gateway',
				metadata: {
					apiKey: 'Api Kaliti',
					baseUrl: 'Asosiy URL',
					allowOrigin: 'Ruxsat manzili',
					readTimeout: "O'qish vaqt (sek)",
					writeTimeout: 'Yozish vaqt (sek)',
					handshakeTimeout: "Qo'zg'alish vaqt (sek)",
					botName: 'Bot nomi',
					telegramToken: 'Telegram BOT API Token',
				},
			},

			callflow: {
				callflow: 'Zvonk',
			},
		},

		ccenter: {
			ccenter: 'Kontakt markazi',

			agents: {
				agents: 'Agent | Agentlar',
				supervisors: 'Supervisor | Supervisorlar',
				admins: 'Admin | Adminlar',
				subordinates: 'Subordinat agent | Subordinat agentlar',
				allAgents: 'Barcha agentlar',
				chatCount: 'Chat soni',
				taskCount: 'Vazifa soni',
				progressiveCountValidator:
					'Qiymat 1 dan katta yoki boʻsh boʻlishi kerak',
				extraChatCount: 'Qoshimcha chatlar soni',
				state: 'Holat',
				isSupervisor: 'Supervisor',
				stateTime: 'Holat vaqti',
				statusType: 'Holat turi',
				addSkill: "Xususiyat qo'shish",
				editSkill: 'Xususiyatni tahrirlash',
				statusHistory: 'Holat tarixi',
				historyState: 'Holat',
				payload: 'Sabab',
				addSubordinate: "Subordinat agent qo'shish",
				historyChannel: 'Kanal',
				historyFrom: 'Dan',
				historyTo: 'Gacha',
				historyDuration: 'Davomiyligi',
				emptyPopup: "Iltimos, filterlar so'rovini tekshiring",
				status: {
					online: 'Onlayn',
					offline: 'Oflayn',
					pause: "To'xtash",
					breakOut: 'Chiqib ketish',
				},
				wfm: 'WFM',
				workingConditions: 'Ish shartlari',
				pauseTemplate: "To'xtash shabloni",
				agentScreenControl: 'Agent ekranini boshqarish',
				agentScreenControlHint:
					'Jamoa uchun sozlama yoqilgan vaqtda o‘chirib bo‘lmaydi',
			},

			auditors: {
				auditors: 'Auditor | Auditorlar',
			},

			teams: {
				teams: 'Jamoa | Jamoalar',
				allTeams: 'Barcha jamoalar',
				strategy: 'Strategiya',
				parameters: 'Parametrlar',
				maxNoAnswer: 'Max noaktivliklar soni',
				callTimeout: 'Zvonk qabul qilish vaqt',
				inviteChatTimeout: 'Chat qabul qilish vaqt',
				wrapUpTime: 'Qoplash vaqti',
				noAnswerDelayTime: 'Noaktivlikdan keyin kutish vaqti',
				taskAcceptTimeout: 'Vazifa qabul qilish vaqt',
				strategies: {
					random: 'Tasodifiy',
					fewestCalls: 'Kam zvonk bilan agent',
					leastTalkTime: 'Kam gaplash vaqti bilan agent',
					topDown: 'Yuqoridan pastga',
					roundRobin: 'Round robin',
					roundRobinBucket: 'Round robin bucket',
					longestIdleAgent: 'Eng uzun uzilgan vaqt bilan agent',
					skillCapacity: "Xususiyat darajasiga ko'ra",
				},
				hooks: {
					eventTypes: {
						agentStatus: "Agent holati o'zgardi",
					},
				},
				flows: {
					addFlowSchema: "Flow sxemasi qo'shish",
					editFlowSchema: 'Flow sxemasi tahrirlash',
				},
				supervisors: {
					addSupervisor: "Supervisor qo'shish",
					editSupervisor: 'Supervisor tahrirlash',
				},
				agents: {
					addAgent: "Agent qo'shish",
					editAgent: 'Agent tahrirlash',
				},
			},

			members: {
				members: "A'zolchalar | A'zolchalar",
				allMembers: "Barcha a'zolchalar",
				addMember: "A'zolchaga qo'shish",
				destination: "Ma'lumotnoma",
				communications: 'Aloqalar',
				display: "Ko'rsatish raqami",
				dtmf: 'DTMF',
				priority: ({ linked }) => linked('objects.memberPriority'),
				attempts: 'Urinishlar',
				emptyWorkspace: "A'zolchalar topilmadi",
				resetMembers: {
					resetMembers: 'Urinishlarini tiklash',
					description: {
						all: 'Sanani cheklamasdan muvaffaqiyatsiz urinishlarni qayta tiklashni xohlaysizmi?',
						filtered:
							'Siz \n{dateFrom} dan {dateTo} gacha\nboʻlgan davrdagi muvaffaqiyatsiz urinishlarni qoʻllanilgan filtrlar va qidiruv natijalariga asoslanib qayta tiklashni xohlaysizmi?',
						selected:
							'Muvaffaqiyatsiz urinishlarni qayta tiklashni xohlaysizmi?',
					},
					descriptionCount: '{count} ta yozuvga taʼsir qiladi.',
					emptyDescription:
						'Joriy filtrlarga mos keluvchi muvaffaqiyatsiz urinishlar yoʻq. Qayta tiklaydigan hech narsa yoʻq.',
					reset: 'Tiklash',
					successResetCount: "Muvaffaqiyatli {count} a'zolchalar tiklandi",
				},
				exportMembers: {
					exportMembers: "A'zolarni eksport qilish",
				},
				endCause: {
					abandoned: ({ linked }) => linked('objects.stopCause.abandoned'),
					timeout: ({ linked }) => linked('objects.stopCause.timeout'),
					cancel: ({ linked }) => linked('objects.stopCause.cancel'),
					success: ({ linked }) => linked('objects.stopCause.success'),
					failed: ({ linked }) => linked('objects.stopCause.failed'),
					missed: ({ linked }) => linked('objects.stopCause.missed'),
					expired: ({ linked }) => linked('objects.stopCause.expired'),
					canceledByTimeout: ({ linked }) =>
						linked('objects.stopCause.canceledByTimeout'),
				},
				csvMappingFields: {
					timezoneId: ({ linked }) => linked('date.timezone'),
					priority: ({ linked }) => linked('vocabulary.priority'),
					expireAt: ({ linked }) => linked('vocabulary.expireAt'),
					bucketId: 'Bucket',
					agentId: ({ linked }) => linked('objects.agent.agent'),
					variables: ({ linked }) => linked('vocabulary.variables'),
					destination: ({ linked }) => linked('vocabulary.destination'),
					commPriority: 'Aloqa turlari ustuvorligi',
					code: 'Kod',
					description: ({ linked }) => linked('vocabulary.description'),
					dtmf: 'DTMF',
				},
			},

			globalStateConfirmation: {
				title: "O'zgarishlarni qo'llash",
				message:
					"O'zgarishlar {count} yozuvga qo'llaniladi. Ishonchingiz komilmi?",
			},

			queues: {
				queues: "Qo'yuv | Qo'yuvlar",
				allQueues: "Barcha qo'yuvlar",
				type: 'Turi',
				state: 'Holat',
				active: 'Aktiv',
				notActive: 'Aktiv emas',
				activeCalls: 'Aktiv zvonkalar',
				waiting: 'Kutish',
				ringtone: 'Zvonk ton',
				priority: 'Prioritet',
				teams: 'Jamoa | Jamoalar',
				tags: 'Teglar',
				newQueue: "Yangi qo'yuv",
				saveBeforeAddingRecords:
					"Yozuvlarni qo'shishdan oldin navbatning majburiy maydonlarini to'ldiring",
				blacklist: "To'xtash ro'yxati",
				resources: ({ linked }) => linked('objects.ccenter.res.res'),
				resourceGroups: ({ linked }) =>
					linked('objects.ccenter.resGroups.resGroups'),
				newQueueDescription: "Yangi qo'yuv tavsifi",
				outboundIVRQueue: "Chiqish IVR qo'yuv",
				outboundIVR: 'Chiqish IVR',
				outboundIVRQueueDescription:
					'Chiqish IVR tizimiga organizatsiya avtomatik tarzda foydalanuvchilarni kutib olish imkonini beradi. Boshqa kanallar orqali avtomatik zvonklar, SMS xabarlar, elektron pochta yoki shaxsiy tarmoqlar orqali personalizatsiyalangan xabarlarni ishlatadi.',
				inboundQueue: "Kirish qo'yuv",
				inboundQueueDescription:
					"Kirish qo'yuv - bu foydalanuvchilar kutib olinadi, qo'yuvda, yutuqlar paydo bo'lganda.",
				offlineQueue: "Oflayn qo'yuv",
				offlineQueueDescription:
					"Oflayn qo'yuv foydalanuvchilar kutib olishni to'xtatish imkonini beradi, telefon raqamini kiritish va ularning ketishiga qadar kelishadi.",
				previewDialer: 'Avvalo dialer',
				previewDialerDescription:
					"Avvalo kontaktni zavodga avtomatik tarzda zavodlashdan oldin uni ko'ring.",
				progressiveDialer: 'Progressiv dialer',
				progressiveDialerDescription:
					"Progressiv zavodlash zvonkalar orasidagi vaqtni tejashadi. Agentlar mavjud bo'lganda avtomatik ravishda raqamni zavodlashadi.",
				predictiveDialer: 'Prediktiv dialer',
				predictiveDialerDescription:
					"Prediktiv dialer bir vaqtning o'zida bir nechta raqamni zovdaladi. Foydalanuvchi javob berganidan keyin agentlar ularga bog'lanadi.",
				chatInboundQueue: "Chat kirish qo'yuv",
				chatInboundQueueDescription:
					"Kirish qo'yuv bilan bir xil, lekin chatlar bilan",
				imChatQueue: "IM chat qo'yuv",
				imChatQueueDescription:
					"Chat qo'yuv bilan bir xil, lekin messenjerlar uchun",
				inboundJobQueue: "Kirish vazifa qo'yuv",
				inboundJobQueueDescription: "Kirish vazifa qo'yuv",
				outboundJobQueue: "Chiqish vazifa qo'yuv",
				outboundJobQueueDescription: "Chiqish vazifa qo'yuv",
				strategy: 'Strategiya',
				timezone: 'Vaqt zonasi',
				callLimit: 'Zvonk limiti',
				variables: "O'zgaruvchilar",
				members: "A'zolchalar | A'zolchalar",
				params: 'Parametrlar',
				discardAbandonedAfter: 'Bekor qilishdan keyin tashlash',
				maxIdleAgent: 'Agent javob vaqti',
				maxIdleClient: 'Foydalanuvchi javob vaqti',
				maxIdleDialog: 'Maksimal javob vaqti',
				timeoutWithNoAgents: "Agentlar yo'qligida vaqt",
				timeBaseScore: 'Vaqt asosida ball',
				endless: 'Cheksiz',
				stickyAgent: 'Sticky agent',
				stickyAgentSec: 'Sticky agent (sek)',
				autoAnswerTone: 'Avtomatik javob xonasi',
				varKey: 'Kalit',
				varVal: 'Qiymat',
				endCause: ({ linked }) => linked('objects.stopCause.stopCause'),
				offeringAt: "Ko'rsatish",
				destination: "Ma'lumotnoma | Ma'lumotnomalar",
				expire: 'Yaroqli',
				originateTimeout: 'Originativ vaqt',
				maxAgentLine: 'Max agent chiziqlari',
				maxAgentLose: "Max agent yo'qolgan zvonkalar",
				minAttempts: 'Min predikt urinishlar',
				maxAbandonedRate: 'Max bekor qilinish %',
				loadFactor: 'Yuk koeffitsienti',
				abandonRateAdjustment: "Bekor qilinish koeffitsientini o'zgartirish",
				playbackSilence: 'Playback siyraha',
				targetAbandonedRate: 'Maqsad bekor qilinish %',
				maxWaitTime: 'Max kutish vaqti',
				maxWaitingSize: 'Max kutish soni',
				waitBetweenRetries: 'Urinishlar orasidagi kutish',
				waitBetweenRetriesDesc: 'Urinishlarini kamaytirish',
				strictCircuit: 'Qattiq sxema',
				retryAbandoned: 'Bekor qilinishni qayta urinish',
				playbackFile: 'Playback fayl',
				timeout: 'Vaqt',
				maxNumberOfRetry: 'Max urinish soni',
				minDuration: 'Minimal muvaffaqiyatli zvonk davomiyligi',
				maxAttempts: 'Max urinishlar',
				minOnlineAgents: "Pausaga kirish uchun mavjud agentlar soni ko'ra",
				waitForResultStatus: 'Natija holati kutish',
				bucketPriority: 'Prioritet',
				amd: 'AMD',
				enabled: 'AMD ishlatish',
				ai: 'Ijrochi intellekt',
				positiveLabels: 'Musbat belgilashlar',
				aiPlayback: 'Playback fayl',
				allowNotSure: 'NOTSUREni agentga uzatish',
				silenceNotSure: 'NOTSUREni agentga uzatish',
				allowGreetingAgent: 'Agentga xush kelibsiz xonasi ruxsat etish',
				preSchema: 'Avvalo-ishchi sxema',
				afterSchema: 'Keyingi-ishchi sxema',
				maxCalls: 'Max vazifalar',
				dialingRate: 'Dialing tezligi',
				maxCallsHint: "Agar qiymat 0 bo'lsa, vazifalar bajarilmaydi",
				recordings: 'Yozuv',
				recordAll: 'Javobdan keyin yozish boshlash',
				perNumbers: 'Har bir telefon raqami uchun dialing urinishlar',
				maxWordLength: "Maksimal so'z uzunligi (ms)",
				maxNumberOfWords: "Maksimal so'zlar soni",
				betweenWordsSilence: "So'zlar orasidagi siyraha (ms)",
				minWordLength: "Minimal so'z uzunligi (ms)",
				totalAnalysisTime: 'Umumiy tahlil vaqti (ms)',
				silenceThreshold: 'Siyraha sharti (ms)',
				afterGreetingSilence: 'Xush kelibsiz siyrahadan keyin (ms)',
				greeting: 'Xush kelibsiz (ms)',
				initialSilence: "Boshlang'ich siyraha (ms)",
				statisticTime: 'Qayta hisoblash intervali',
				communications: 'Kommunikatsiya turi',
				manualDistribution: "Iste'g'lovchi taqsimlash",
				lastMessageTimeout: 'Oxirgi xabardan keyin vaqt',
				stickyIgnoreStatus: 'Agent holati kuzatishni boshqarish',
				ignoreCalendar: 'Kalendar kuzatishni boshqarish',
				resourceStrategy: {
					resourceStrategy: 'Resurs strategiyasi',
					priorityBased: 'Prioritet asosida',
					evenDistribution: 'Teng taqsimlash',
				},
				attemptsReset: {
					resetActiveAttempts: ({ linked }) =>
						linked('objects.permissions.roles.permissions.resetActiveAttempts'),
					title: 'Urinishlarni tiklash',
					attemptType: 'Urinish turi',
					idleTime: 'Uzilgan vaqti (min)',
					result: ({ linked }) =>
						linked('objects.integrations.triggers.logs.result'),
					calls: 'Zvonkalar',
					attemptsCount: 'Urinishlar',
				},
				processing: {
					processing: 'Bajarilmoqda',
					enabled: 'Zvonk natijasi kutish',
					formSchema: 'Dinamik tahrirlash sxemasi',
					sec: 'Posttizim vaqti (sek)',
					renewalSec:
						"Qolgan (sek) bo'lganda posttizimni uzaytirishni taklif qilish",
					allowProlongation: 'Posttizimni uzaytirishga ruxsat berish',
					autosave: 'Posttizimni avtomatik saqlashga ruxsat berish',
					repeatsNumber: 'Takrorlashlar soni',
					prolongationTimeSec: 'Uzaytirish vaqti (sek)',
					isTimeoutRetry: 'Vaqt tugagunga qadar qayta urinish',
				},
				queueStrategy: {
					fifo: 'FIFO (Birinchi kirish, birinchi chiqish)',
					lifo: 'LIFO (Oxirgi kirish, birinchi chiqish)',
					strict_fifo: 'Qattiq FIFO (Birinchi kirish, birinchi chiqish)',
				},
				logs: {
					logs: 'Log | Loglar',
					destination: "Ma'lumotnoma",
					offeringAt: "Ko'rsatish",
					joinedAt: 'Boshlanish',
					leavingAt: 'Tugash',
					duration: ({ linked }) => linked('vocabulary.duration'),
					viewNumber: "Ko'rish raqami",
					result: ({ linked }) => linked('objects.callReportingResult.result'),
					attempts: 'Urinishlar',
					resultName: {
						abandoned: ({ linked }) =>
							linked('objects.callReportingResult.abandoned'),
						cancel: ({ linked }) =>
							linked('objects.callReportingResult.cancel'),
						success: ({ linked }) =>
							linked('objects.callReportingResult.success'),
						failed: ({ linked }) =>
							linked('objects.callReportingResult.failed'),
						missed: ({ linked }) =>
							linked('objects.callReportingResult.missed'),
						timeout: ({ linked }) =>
							linked('objects.callReportingResult.timeout'),
						endless: ({ linked }) =>
							linked('objects.callReportingResult.endless'),
						transferred: ({ linked }) =>
							linked('objects.callReportingResult.transferred'),
						shutdown: ({ linked }) =>
							linked('objects.callReportingResult.shutdown'),
					},
				},
				hooks: {
					hooks: 'Hook | Hooklar',
					event: 'Hodisa',
					eventTypes: {
						joined: 'Kirish',
						answered: 'Javob berilgan',
						offering: "Ko'rsatish",
						bridged: 'Birlashtirilgan',
						missed: 'Bekor qilindi',
						leaving: 'Chiqib ketish',
						processing: 'Bajarilmoqda',
						active: 'Aktiv',
					},
				},
				skills: {
					editSkill: 'Xususiyatni tahrirlash',
					addSkill: "Xususiyat qo'shish",
				},
				buckets: {
					addBucket: "Bucket qo'shish",
					editBucket: 'Bucket tahrirlash',
				},
			},

			res: {
				res: 'Resurs | Resurslar',
				allRes: 'Barcha resurslar',
				reserve: 'Rezervatsiya',
				searchPlaceholder: 'nom, gateway..',
				cps: 'CPS',
				limit: 'Limit',
				cidType: 'CID turi',
				ignoreEarlyMedia: 'Oldindan kelgan media-fayllarni kuzatish',
				numbers: 'Raqam | Raqamlar',
				displayNumbers: "Ko'rsatish raqamlari",
				failure: 'Yaroqsiz',
				maxErrors: 'Maksimal yaroqsiz javoblar soni',
				errorCodes: 'Yaroqsiz javoblar kodi',
				patterns: "Ma'lumotnoma raqami shablonlari",
				priority: 'Prioritet',
				reserveResource: 'Resursni rezervatsiya qilish',
				failureDialDelay: 'Yaroqsiz dial vaqti',
				csvMappingFields: {
					number: ({ linked }) => linked('vocabulary.number'),
				},
			},

			resGroups: {
				resGroups: 'Resurs guruhi | Resurs guruhlari',
				allResGroups: 'Barcha resurs guruhlari',
				searchPlaceholder: 'res guruhi nomi..',
				addResGroup: "Resurs guruhi qo'shish",
				editResGroup: 'Resurs guruhi tahrirlash',
				strategy: 'Strategiya',
				timerange: "Vaqt oralig'i",
				timerangeFrom: 'Dan',
				timerangeTo: 'Gacha',
			},
		},

		integrations: {
			integrations: 'Integratsiyalar',
			emptyWorkspace: "Hozircha profillar yo'q",

			storage: {
				storage: 'Saqlash',
				allStorages: 'Barcha saqlashlar',
				type: 'Turi',
				maxSize: 'Saqlash fazosi (GB)',
				expireDays: 'Yil (kunlar)',
				priority: 'Prioritet',
				newStorage: 'Yangi saqlash',
				newStorageDescription: 'Yangi saqlash tavsifi',
				local: 'Lokal',
				s3: 'S3 Bucket',
				digitalOcean: 'Digital Ocean Spaces',
				backblaze: 'Backblaze B2',
				dropbox: 'Dropbox',
				drive: 'Google Drive',
				configuration: 'Konfiguratsiya',
				pathPattern: "Yo'l shablonlari",
				localFolder: 'Lokal papka',
				s3Key: 'Kalit ID',
				s3Access: 'Kalit',
				bucket: 'Bucket',
				region: 'Maydon',
				oceanKey: 'Kalit ID',
				oceanAccess: 'Kalit',
				backblazeAccount: 'Hisob ID',
				backblazeKey: 'Ilova kaliti',
				backblazeBucketId: 'Bucket ID',
				dropboxKey: 'Token',
				driveFolder: 'Papka nomi',
				driveEmail: 'Google Email',
				driveKey: 'Maxfiy kalit',
				s3Endpoint: 'Endpozit',
			},

			storagePolicies: {
				storagePolicies: 'Saqlash siyosati | Saqlash siyosatlari',
				mimeTypes: 'MIME turlari',
				retentionDays: 'Saqlash davri (kunlar)',
				maxDownloadSpeed: 'Maksimal yuklash tezligi (kbps)',
				maxUploadSpeed: 'Maksimal yuklash tezligi (kbps)',
				maxUploadSize: "Maksimal yuklash o'lchami (baytlar)",
				applyToFiles: "Mavjud fayllarga saqlash muddatini qo'llash",
				applyPopupMessage:
					"Yangi saqlash davri mavjud fayllarga siyosat asosida qo'llaniladi. Siz davom etishni xohlaysizmi?",
				channels: {
					[StorageUploadFileChannel.CallChannel]: 'zvonk',
					[StorageUploadFileChannel.ChatChannel]: 'chat',
					[StorageUploadFileChannel.MediaChannel]: 'media',
					[StorageUploadFileChannel.MailChannel]: 'elektron pochta',
					[StorageUploadFileChannel.LogChannel]: 'log',
					[StorageUploadFileChannel.ScreenRecordingChannel]: 'ekran yozuvlari',
				},
				encryptFile: 'Yangi fayllarni shifrlash',
				encryptFileHint:
					'Shifrlash kaliti yoʻqolsa, fayllarni shifrdan chiqa olmaysiz! Yozuvlarga faqat API yoki interfeys orqali kirish mumkin.',
				encryptionAlertTitle: 'Shifrlash haqida ogohlantirish',
				encryptionEnableMessage: 'Faqat yangi fayllar shifrlangan boʻladi.',
				encryptionDisableMessage:
					'Eski fayllar shifrlangan holatda qoladi.\nYangi fayllar shifrlanmaydi.',
			},

			cognitiveProfiles: {
				cognitiveProfiles: 'Ijrochi profili | Ijrochi profillar',
				properties: {
					region: 'Maydon',
					locale: 'Til',
				},
			},
			emailProfiles: {
				emailProfiles: 'Elektron pochta profili | Elektron pochta profillar',
				mailbox: 'Mailbox',
				smtpPort: 'SMTP Port',
				imapPort: 'IMAP Port',
				smtpHost: 'SMTP Host',
				imapHost: 'IMAP Host',
				fetchInterval: 'Yangilash davri',
				listen: 'Kuzatish',
				authType: 'Autentifikatsiya turi',
				authenticatedAs: 'Autentifikatsiya qilingan',
			},
			singleSignOn: {
				singleSignOn: 'SSO profil | SSO profillari',
				provider: 'Provayder',
				clientId: 'Application (client) ID',
				clientSecret: 'Client secret',
				discoveryUrl: 'Discovery URL',
				scopes: 'Ruxsatlar',
				scopesPlaceholder: 'Ruxsatni kiriting va Enter bosing',
				inspect: 'Inspect',
				inspectHint: 'Provayderga so rov yuborish va token olish',
				token: 'Token',
				showToken: 'Tokenni ko‘rsatish',
				inspectDescription: 'Provayderga so rov yuborish va token olish',
				mapping: 'Moslash',
				mappingKeyHint:
					'Foydalanuvchi atributini kiriting (masalan, email, username, extension) qidiruv kaliti sifatida.',
			},

			importCsv: {
				importCsv: 'CSV fayldan import qilish | CSV fayldan importlar',
				allImportsCsv: "Barcha CSV fayldan import ma'lumotlari",
				source: 'Import manzili',
				settings: 'Sozlamalar',
				mappings: 'Maydon nomlarini kiritish',
				mappingsHint:
					"Bu bo'limda siz quyidagi CSV fayl ustunlarini kiritishda quyidagi nomlariga mos kelishi kerak",
				columnHeader: '{name} ustuni',
				members: {
					clearMembers: "Mavjud a'zolchalar tozalash",
				},
			},

			tokens: {
				tokens: 'Token | Tokens',
				allTokens: 'Barcha tokenlar',
				expires: "Yaroqli bo'lishi",
				popupMessage:
					'Endi yoki uni nusxasini oling. Agar siz hozircha kalit faylini yuklamasangiz, siz kalit faylingizni qayta olishimiz mumkin emas. Sizning sekuritynizni himoya qilish uchun kalit faylingizni xavfsiz saqlang va uni boshqarish.',
				tokenCreated: 'Sizning tokeningiz muvaffaqiyatli yaratildi!',
			},

			triggers: {
				triggers: 'Trigger | Triggerlar',
				allTriggers: 'Barcha triggerlar',
				type: 'Turi',
				schema: 'Sxema',
				newTrigger: 'Yangi trigger',
				newTriggerDescription:
					"Boshlash yoki bo'sh qalam bilan boshlash uchun shablonni tanlang yoki boshlang",
				event: 'Hodisa',
				onEventDescription: 'Hodisa asosida JSON sxemasi rejimi',
				cron: 'Vaqt',
				atTimeDescription: 'Vaqt asosida JSON sxemasi rejimi',
				eventSelect: ({ linked }) =>
					linked('objects.ccenter.queues.hooks.event'),
				cases: 'Hollar',
				caseFiles: 'Hollar fayllari',
				caseComments: 'Hollar izohlari',
				caseLinks: 'Hollar boglanishlar',
				call: "Qo'ng'iroq",
				relatedCases: "Bog'lanishli hollar",
				expression: 'Ifoda',
				timeout: 'Vaqt',
				resolutionTime: ({ linked }) => linked('cases.resolutionTime'),
				logs: {
					logs: 'Ish tarixi',
					startedAt: 'Boshlanish',
					result: 'Natija',
				},
				recordCall: "Qo'ng'iroqni yozib olish",
			},
		},
		system: {
			system: 'Tizim',
			changelogs: {
				changelogs: "O'zgarish logi | O'zgarish loglari",
				objects: 'Obyekt | Obyektlar',
				daysToStore: 'Saqlash davri (kunlar)',
				storage: 'Yuklashga',
				logs: {
					logs: 'Log | Loglar',
					actions: 'Amal | Amallar',
					records: 'Yozuv ID | Yozuv IDlar',
					actionType: {
						[LoggerAction.Create]: 'Yaratish',
						[LoggerAction.Delete]: "O'chirish",
						[LoggerAction.Update]: 'Tahrirlash',
					},
				},
				period: {
					period: 'Davri',
					options: {
						daily: 'Kunlik',
						weekly: 'Haftalik',
						fortnightly: 'Oylik',
						monthly: 'Oylik',
					},
				},
			},
			configuration: {
				configuration: 'Konfiguratsiya | Konfiguratsiyalar',
				parameter: 'Parametr',
			},
			globalVariables: {
				globalVariables: "Global o'zgaruvchi | Global o'zgaruvchilar",
				encrypted: 'Shifrlangan',
				valueInfo:
					"Qiymatni o'zgartirmoqchi bo'lsangiz, bo'sh maydonga qo'ying",
				newTitle: "Yangi global o'zgaruvchi",
				editTitle: "Global o'zgaruvchini tahrirlash",
			},
		},

		pagination: {
			rowsPerPage: 'Sahifa ustunlari',
		},
	},

	filters: {
		team: 'Jamoa',
		queueType: "Qo'yuv turi",
	},

	webitelUI: {
		filters: {
			tags: ({ linked }) => linked('vocabulary.tag'),
			joinedAt: ({ linked }) => linked('objects.joinedAt'),
			result: ({ linked }) => linked('objects.callReportingResult.result'),
			duration: ({ linked }) => linked('vocabulary.duration'),
		},
	},

	utils: {
		downloadFilesBtn: {
			downloadFiles: 'Fayllarni yuklash',
			filesLoaded: 'Fayllar yuklandi',
			zippingProgress: 'Ziplash jarayoni',
		},
	},

	errorPages: {
		goToHome: "Bosh sahifaga o'tish",
		page403: {
			title: 'Ruxsat etilmadi',
			text: "Kechirasiz, siz bu sahifani ko'rishga ruxsat yetmadingiz.",
		},
		page404: {
			title: "Ko'rinayotgan bo'lsangiz, siz yo'l bilan yo'q",
			text: 'Kechirasiz, siz xohlagan sahifani topolmadingiz.',
		},
	},

	icon: {
		docs: "Do'kon",
		logout: 'Chiqish',
		account: 'Hisob',
		appNavigator: 'Dasturlar navigatori',
		settings: 'Sozlamalar',
	},

	iconHints: {
		upload: 'Yuklash',
		reload: 'Jadvalni yangilash',
		edit: 'Tahrirlash',
		delete: "O'chirish",
		deleteAll: "Barcha ma'lumotlarni o'chirish",
		deleteSelected: "Tanlangan {count} ma'lumotni o'chirish",
		deleteFiltered: "Barcha filtrlangan ma'lumotlarni o'chirish",
		resetAll: "Barcha a'zolchalarni tiklash",
		resetSelected:
			"Tanlangan {count} a'zolchalarni tiklash | Tanlangan {count} a'zolchalarni tiklash",
		resetFiltered: "Barcha filtrlangan a'zolchalarni tiklash",
		generate: 'Yaratish',
		add: "Qo'shish",
		history: 'Tarix',
		download: 'Yuklash',
		downloadAll: 'Barcha yuklash',
		draggable: 'Tortish mumkin',
		play: "O'ynash",
		pause: "To'xtatish",
		stop: "To'xtatish",
		close: 'Yopish',
		change: "O'zgartirish",
		volume: 'Haqiqat',
		members: "A'zolchalar",
		moveUp: "Yuqoriga ko'chirish",
		moveDown: "Pastga ko'chirish",
		nextPage: 'Keyingi sahifa',
		prevPage: 'Oldingi sahifa',
		expand: 'Kengaytirish',
		collapse: 'Qisqartirish',
	},
	errors: {
		invalidJson: "JSON noto'g'ri",
	},
	reusable: {
		time: {
			t15m: '15 daqiqa',
			t30m: '30 daqiqa',
			t45m: '45 daqiqa',
			t1h: '1 soat',
			t3h: '4 soat',
			t6h: '6 soat',
		},
	},
};
